<template>
  <v-card
    color="#f9f9f9"
    :disabled="!$isLoggedIn"
    elevation="1"
    @click.prevent="toggle()"
  >
    <v-card-text
      class="text-center"
    >
      <v-icon
        color="#bf7b7b"
      >
        {{ isLiked ? 'favorite' : 'favorite_border' }}
      </v-icon>
      <div
        :class="{ 'd-inline-block ml-2': vertical, 'mt-1': !vertical }"
      >
        {{ totalLikes }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { UserServerLike } from '@serversgg/sdk-js'

export default {
  name: 'ServerLikeButton',

  props: {
    server: {
      required: true,
      type: Object,
    },
    vertical: {
      default: false,
      type: Boolean,
    },
  },

  data () {
    return {
      adjust: 0,
    }
  },

  computed: {
    isLiked () {
      return this.$store.state.likedServers.items
        .findIndex(likedServer => likedServer.data.server_id === this.server.data.id) > -1
    },

    totalLikes () {
      return this.server.data.likes_count + this.adjust
    },
  },

  methods: {
    async toggle () {
      if (!this.isLiked) {
        const userServerLike = new UserServerLike({
          server_id: this.server.data.id,
        })

        await userServerLike
          .request()
          .setUriParam('user_id', this.$user.data.id)
          .save()

        this.$notify('info', this.$t('liked'))

        this.adjust += 1
        this.$store.commit('likedServers/add', userServerLike)
      } else {
        const userServerLikes = await UserServerLike
          .request()
          .setUriParam('user_id', this.$user.data.id)
          .fetch({
            server_id: this.server.data.id,
          })

        const userServerLike = userServerLikes.first()
        const userServerLikeId = userServerLike.data.id

        await userServerLike
          .request()
          .destroy()

        this.$notify('info', this.$t('like_removed'))

        this.adjust -= 1
        this.$store.commit('likedServers/remove', userServerLikeId)
      }
    },
  },
}
</script>
